import React, { useState } from "react";
import NoteContext from "./noteContext";



const NoteState = (props) =>{
  const host = "https://task-management-system-reactapp-1.onrender.com"
    const notesInitial = []
    const [notes, setNotes] = useState(notesInitial)


    //--GET ALL  NOTES---
    const getNotes = async() =>{
      //---API CALL----
      const response = await fetch(`${host}/api/notes/fetchallnotes`, {
        method: "GET", 
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("token")
        },
      });

    const json = await response.json();
    console.log(json);
    setNotes(json)
  }

    //Add a Note
    const addNote = async(title, description, tag) =>{
        //---API CALL----http://localhost:5000/api/notes/addNote
        const response = await fetch(`${host}/api/notes/addnote`, {
          method: "POST", 
          headers: {
            "Content-Type": "application/json",
            "auth-token": localStorage.getItem("token")
          },
      
          body: JSON.stringify({title, description, tag}),
        });
      
        const note = await response.json();
        setNotes(notes.concat(note));
    }

    //Delete a Note
    const deleteNote = async (id)=>{
      //API CALL
      const response = await fetch(`${host}/api/notes/deletenote/${id}`, {
        method: "DELETE", 
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("token")
        },
    
        // body: JSON.stringify(title, description, tag),
      });
     const data = await response.json();
      console.log(data);
      //----LOGIC TO DELETE-----
      console.log("deleting note with id"+ id);
      const newNotes = notes.filter((note)=>{return note._id!==id})
      setNotes(newNotes);
    }

    //Edit a Note
    const editNote = async(id, title, description, tag) => {
      //API CALL         
    const response = await fetch(`${host}/api/notes/updatenote/${id}`, {
    method: "PUT", 
    headers: {
      "Content-Type": "application/json",
      "auth-token": localStorage.getItem("token")
    },

    body: JSON.stringify({title, description, tag}),
  });

    const json = await response.json(); 
    console.log(json);
    let newNotes = await JSON.parse(JSON.stringify(notes))
    //   //LOGIC TO EDIT IN CLIENT
    //   for(let index=0; index<newNotes.length; index++){
    //     const element = newNotes[index];
    //     if(element.id===id){
    //       element.title=title;
    //       newNotes[index].description=description;
    //       newNotes[index].tag=tag;
    //       break;

    //     }

        
    //   }

      setNotes(newNotes);
      getNotes();

    }

    return (
        <NoteContext.Provider value={{notes, addNote, deleteNote, editNote, getNotes}}>
            {props.children}
        </NoteContext.Provider>
    )
}


export default NoteState;